import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUmbrellaToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.36914 6.26312C5.09103 6.41224 7.01609 6.71049 8.94114 6.71049C10.8662 6.71049 12.7912 6.41224 13.5131 6.26312",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.48145 9.39476C2.65927 9.69301 5.80015 10.2895 8.94102 10.2895C12.0819 10.2895 15.2228 9.69301 16.4006 9.39476",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 12.5264C2.25382 12.9738 5.59733 13.8685 8.94084 13.8685C12.2843 13.8685 15.6279 12.9738 16.8817 12.5264",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.21906 1.78943C7.25653 5.81576 1.00012 6.93418 1 11.1842C0.999882 15.4377 3.64706 17 8.94095 17",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.66278 1.78943C10.6253 5.81576 16.8817 6.93418 16.8818 11.1842C16.882 15.4377 14.2348 17 8.94088 17",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.7002 1.78943C8.15019 6.13029 4.85016 7.09493 4.8501 11.677C4.85003 16.2628 7.37102 17.1432 8.7002 16.9824",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.18164 1.78943C9.73164 6.13029 13.0317 7.09493 13.0317 11.677C13.0318 16.2628 10.5108 17.1432 9.18164 16.9824",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9.2002,
			y1: 1.78943,
			x2: 9.2002,
			y2: 17,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 6,
			y1: 1.5,
			x2: 12,
			y2: 1.5,
			stroke: "currentColor"
		})
	]
});
export default SvgUmbrellaToolbar;
